<section class="register-area">
    <div class="row m-0">
        <div class="col-lg-6 col-md-12 p-0">
            <div class="register-image">
                <img src="assets/img/register-bg.jpg" alt="image">
            </div>
        </div>

        <div class="col-lg-6 col-md-12 p-0">
            <div class="register-content">
                <div class="d-table">
                    <div class="d-table-cell">
                        <div class="register-form">
                            <div class="logo">
                                <a routerLink="/"><img src="assets/img/black-logo.png" alt="image"></a>
                            </div>

                            <h3>Create Your Account Now</h3>
                            <p>Already register? &nbsp;
                                <a routerLink="/login">
                                    Login
                                </a>
                            </p>

                            <form>
                                <div class="form-group">
                                    <input type="email" placeholder="Enter Your Name" class="form-control">
                                </div>

                                <div class="form-group">
                                    <input type="email" placeholder="Enter Your Email" class="form-control">
                                </div>

                                <div class="form-group">
                                    <input type="password" placeholder="Enter Your Password" class="form-control">
                                </div>

                                <div class="form-group">
                                    <input type="password" placeholder="Confirm Your Password" class="form-control">
                                </div>

                                <button type="submit">Signup</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>